import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import PricingCards from '../components/Pricing'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import MultiItemCarousel from '../components/partners/MultiItemCarousel';


const Pricing = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Entries' text='Secure your pass by choosing the pass type that applies to you.' />
            <PricingCards />
            <Banner />
            <MultiItemCarousel />
            <Footer />
        </div>
    )
}

export default Pricing
